import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Form, Spin } from 'antd';
import { FaRegTrashAlt, FaEdit } from 'react-icons/fa';
import { PlusOutlined } from '@ant-design/icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../api/Api';
import ValoresInput from '../PercentagemInput';

const TaxasImpostos = () => {
  const [impostos, setImpostos] = useState([]);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [selectedImposto, setSelectedImposto] = useState(null);
  const [impostoToDelete, setImpostoToDelete] = useState(null);
  const [loading, setLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    document.title = 'Taxas de Impostos';
    fetchImpostos();
  }, []);

  const sms_error = (msg) => toast.error(msg);
  const sms_success = (msg) => toast.success(msg);

  const fetchImpostos = async () => {
    setLoading(true);
    try {
      const response = await Api.ListImposto();
      const dados = Array.isArray(response) ? response : [];

      const formatado = dados.map(item => ({
        key: item.id,
        id: item.id,
        descricao: item.descricao,
        percentagem: item.percentagem.replace('.',',')
      }));

      setImpostos(formatado);
    } catch (error) {
      sms_error('Erro ao buscar impostos: ' + (error.message || 'Erro desconhecido'));
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async (values) => {
    setAddLoading(true);
    try {
      const result = await Api.AddImposto({
        descricao: values.descricao,
        percentagem: values.percentagem
      });

      if (result.success) {
        sms_success('Imposto adicionado com sucesso!');
        setIsAddModalVisible(false);
        form.resetFields();
        await fetchImpostos();
      } else {
        sms_error(result.message || 'Erro ao adicionar imposto');
      }
    } catch (error) {
      sms_error('Erro ao adicionar imposto: ' + error.message);
    } finally {
      setAddLoading(false);
    }
  };

  const handleEdit = async (values) => {
    setEditLoading(true);
    try {
      const result = await Api.AlterImposto({
        id: selectedImposto.id,
        descricao: values.descricao,
        percentagem: values.percentagem
      });

      if (result.success) {
        sms_success('Imposto editado com sucesso!');
        setIsEditModalVisible(false);
        editForm.resetFields();
        await fetchImpostos();
      } else {
        sms_error(result.message || 'Erro ao editar imposto');
      }
    } catch (error) {
      sms_error('Erro ao editar imposto: ' + error.message);
    } finally {
      setEditLoading(false);
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await Api.DeleteImposto({ id: impostoToDelete });
      if (result.success) {
        sms_success('Imposto excluído com sucesso!');
        await fetchImpostos();
      } else {
        sms_error(result.message || 'Erro ao excluir imposto');
      }
    } catch (error) {
      sms_error('Erro ao excluir imposto: ' + error.message);
    } finally {
      setDeleteLoading(false);
      setIsDeleteModalVisible(false);
    }
  };

  const columns = [
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      key: 'descricao'
    },
    {
      title: 'Percentagem',
      dataIndex: 'percentagem',
      key: 'percentagem',
      render: (valor) => `${valor}`
    },
    {
      title: 'Ações',
      key: 'acoes',
      render: (_, record) => (
        <div style={{ display: 'flex', gap: 10 }}>
          <FaEdit
            style={{ cursor: 'pointer', color: '#1890ff' }}
            onClick={() => {
              setSelectedImposto(record);
              editForm.setFieldsValue({
                descricao: record.descricao,
                percentagem: record.percentagem
              });
              setIsEditModalVisible(true);
            }}
          />
          <FaRegTrashAlt
            style={{ cursor: 'pointer', color: '#ff4d4f' }}
            onClick={() => {
              setImpostoToDelete(record.id);
              setIsDeleteModalVisible(true);
            }}
          />
        </div>
      )
    }
  ];

  return (
    <div>
      <ToastContainer />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setIsAddModalVisible(true)}
        >
          Adicionar
        </Button>
      </div>

      <Spin spinning={loading} tip="Carregando...">
        <Table columns={columns} dataSource={impostos} rowKey="id" />
      </Spin>

      {/* Modal Adicionar */}
      <Modal
        title="Adicionar Imposto"
        open={isAddModalVisible}
        onCancel={() => {
          form.resetFields();
          setIsAddModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleAdd}>
          <Form.Item
            name="descricao"
            label="Descrição"
            rules={[{ required: true, message: 'Descrição é obrigatória' }]}
          >
            <Input maxLength={50} />
          </Form.Item>

       <Form.Item
  name="percentagem"
  label="Percentagem (%)"
  rules={[{ required: true, message: 'Percentagem é obrigatória' }]}
>
           <ValoresInput />
          </Form.Item>

          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ marginRight: 8 }}
                onClick={() => {
                  form.resetFields();
                  setIsAddModalVisible(false);
                }}
                disabled={addLoading}
              >
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={addLoading}>
                {addLoading ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal Editar */}
      <Modal
        title="Editar Imposto"
        open={isEditModalVisible}
        onCancel={() => {
          editForm.resetFields();
          setIsEditModalVisible(false);
        }}
        footer={null}
        destroyOnClose
      >
        <Form form={editForm} layout="vertical" onFinish={handleEdit}>
          <Form.Item
            name="descricao"
            label="Descrição"
            rules={[{ required: true, message: 'Descrição é obrigatória' }]}
          >
            <Input maxLength={50} />
          </Form.Item>

          <Form.Item
            name="percentagem"
            label="Percentagem (%)"
            rules={[
              { required: true, message: 'Percentagem é obrigatória' },
              
            ]}
          >
             <ValoresInput />
          </Form.Item>

          <Form.Item>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                style={{ marginRight: 8 }}
                onClick={() => {
                  editForm.resetFields();
                  setIsEditModalVisible(false);
                }}
                disabled={editLoading}
              >
                Cancelar
              </Button>
              <Button type="primary" htmlType="submit" loading={editLoading}>
                {editLoading ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal Exclusão */}
      <Modal
        title="Confirmar Exclusão"
        open={isDeleteModalVisible}
        onOk={handleDelete}
        onCancel={() => setIsDeleteModalVisible(false)}
        okText="Sim"
        cancelText="Não"
        confirmLoading={deleteLoading}
      >
        <p>Tem certeza que deseja excluir esta taxa de imposto?</p>
      </Modal>
    </div>
  );
};

export default TaxasImpostos;
